import { gql } from '@apollo/client';

export default gql`
  fragment questionFragment on Question {
    _id
    categoryDescription
    categoryKeyword
    icon
    order
    questions {
      id
      title
      content
      keyword
    }
  }
`;
